import * as React from 'react';
import { useCallback, useState } from 'react';
import type { Without } from '@/types/generic';

// TODO: fix typings
export type UICheckboxProps = any; // {
//   name: string;
//   label?: string;
//   value?: string;
//   onChange?: (value: string) => void;
// } & Without<React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'onChange'>;

export const UICheckbox =
  ({ name, label, value, onChange, ...inputProps }: UICheckboxProps) => {
    const [checked, setChecked] = useState(null);
    const handleChange = useCallback<React.InputHTMLAttributes<HTMLInputElement>['onChange']>((event) => {
      const newValue = event.target.checked;
      onChange?.(newValue ? 'on' : '');
      if (typeof checked !== 'undefined') setChecked(newValue);
    }, [onChange, setChecked, typeof value]);

    const valueToUse = typeof value !== 'undefined' ? value === 'on' : checked === true;
    return (
      <div className="ui-checkbox">
        <label
          htmlFor={name}
          className={`ui-btn ui-corner-all ui-btn-inherit ui-btn-icon-left ui-checkbox-${valueToUse ? 'on' : 'off'}`}
        >
          {label}
        </label>
        <input
          type="checkbox"
          name={name}
          id={name}
          checked={valueToUse}
          data-role="none"
          onChange={handleChange}
          {...inputProps} // eslint-disable-line react/jsx-props-no-spreading
        />
      </div>
    );
  };
